import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { HelpCircle, Music2, ChevronRight } from 'lucide-react';
import { useMobile } from './MobileContext';
import { MobileShell, MobileHeader, C } from './MobileShell';

export default function MobileTools() {
  const nav = useNavigate();
  const { me, loading } = useMobile();

  if (loading) return <MobileShell><div className="flex-1 flex items-center justify-center" style={{ color: C.dim }}>Laden…</div></MobileShell>;
  if (!me) return <Navigate to="/m/login" replace />;

  return (
    <MobileShell>
      <MobileHeader title="Tools" backTo="/m" />
      <div className="px-4 pt-4 pb-2">
        <span className="text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded"
              style={{ background: '#3a2325', color: C.red }} data-testid="tools-beta-badge">Beta</span>
        <p className="text-xs mt-2" style={{ color: C.dim }}>
          Kleine Übungs-Spiele für zwischendurch – dein Fortschritt landet in der Bestenliste deiner Musikschule.
        </p>
      </div>

      <div className="mx-4 mt-2 rounded-xl overflow-hidden" style={{ border: `1px solid ${C.border}` }}>
        <button onClick={() => nav('/m/tools/quiz')} data-testid="tools-quiz-tile"
                className="w-full flex items-center gap-3 px-4 py-4 text-left active:opacity-70"
                style={{ background: C.card, borderBottom: `1px solid ${C.border}`, color: C.text }}>
          <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: '#2a1e3f' }}>
            <HelpCircle className="w-5 h-5" style={{ color: '#a78bfa' }} />
          </div>
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-semibold">Musiktheorie-Quiz</span>
            <span className="block text-xs" style={{ color: C.dim }}>4 Kategorien · 3 Schwierigkeitsgrade · Bestenliste</span>
          </span>
          <ChevronRight className="w-4 h-4" style={{ color: C.dim }} />
        </button>

        <button onClick={() => nav('/m/tools/melody')} data-testid="tools-melody-tile"
                className="w-full flex items-center gap-3 px-4 py-4 text-left active:opacity-70"
                style={{ background: C.card, color: C.text }}>
          <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: '#1e2f3f' }}>
            <Music2 className="w-5 h-5" style={{ color: '#60a5fa' }} />
          </div>
          <span className="flex-1 min-w-0">
            <span className="block text-sm font-semibold">Melodie raten</span>
            <span className="block text-xs" style={{ color: C.dim }}>Melodie anhören & auf der Klaviatur nachspielen</span>
          </span>
          <ChevronRight className="w-4 h-4" style={{ color: C.dim }} />
        </button>
      </div>
    </MobileShell>
  );
}
